import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { ContentLayout4 } from '@components/content/components/content-layout-4/model';
import { BuildTitlePipe } from '@components/content/components/content-layout-4/pipe';
import { ResponsiveService } from '@services/responsive';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';

@Component({
  selector: 'app-content-layout-4',
  imports: [TitleComponent, BuildTitlePipe],
  templateUrl: './content-layout-4.component.html',
  styleUrl: './content-layout-4.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout4Component implements OnInit {
  readonly data = input.required<ContentLayout4>();
  breakpoints = inject(ResponsiveService).breakpoints;
  title = signal<Title>(null!);
  subTitle = signal<Title>(null!);
  readonly baseTitle = signal<Title>({
    level: 'SPAN',
    weight: 700,
    font: 'IVY_MODE',
    size: {
      desktop: 'H4',
      mobile: 'H4',
      custom: {
        mobile: '2rem',
      },
    },
    color: 'BLACK',
    align: {
      mobile: 'LEFT',
      desktop: 'LEFT',
    },
    text: '',
  });

  ngOnInit(): void {
    this.title.set({
      level: 'H3',
      size: {
        mobile: 'H2',
        desktop: 'H3',
      },
      color: 'BLACK',
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().title,
    });
    this.subTitle.set({
      level: 'SPAN',
      size: {
        mobile: 'SPAN',
        desktop: 'SPAN',
      },
      weight: 500,
      color: 'GREY_LIGHT',
      type: 'SLASH',
      text: this.data().subtitle,
    });
  }
}
